<template>
  <div>
    <v-treeview
      :key="treeKey"
      :active.sync="active"
      :items="treeItems"
      :load-children="getChildren"
      :open.sync="open"
      item-key="_id"
      open-on-click
      activatable
      transition
      style="border: solid #8f8f8f 1px"
    >
      <template v-slot:label="{ item }">
        <div
          class="d-flex align-center justify-space-between w-100"
          style="max-width: 100%"
        >
          <div>
            {{ item.name }}
          </div>
          <div>
            <input
              type="radio"
              name="directoriyRadio"
              @change="onClick(item)"
              @click.stop
            />
          </div>
        </div>
      </template>

      <template v-slot:prepend="{ item }">
        <v-icon>
          {{ open.includes(item._id) ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "TreeForMoving",
  data() {
    return {
      open: [],
      active: [],
      selectedId: null,
      treeItems: [],
      treeKey: 0,
    };
  },
  props: {
    itemId: { type: String, required: true },
  },
  created() {
    this.loadRootItems();
  },
  methods: {
    async loadRootItems() {
      try {
        const response = await Vue.axios.get("leodata/directory/root/content");
        const directory = response.data.directory;
        const children = directory.children.directories
          .filter((d) => d._id != this.itemId)
          .map((d) => ({
            _id: d._id,
            name: d.name,
            children: [],
            hasChildren: true,
          }));
        this.treeItems = children;
      } catch (error) {
        console.error("Erreur chargement racine", error);
      }
    },
    async getChildren(item) {
      try {
        const response = await Vue.axios.get(
          `leodata/directory/${item._id}/content`
        );
        const directory = response.data.directory;
        const children = directory.children.directories
          .filter((d) => d._id != this.itemId)
          .map((d) => ({
            _id: d._id,
            name: d.name,
            children: [],
            hasChildren: true,
          }));
        item.children = children;
      } catch (error) {
        console.error("Erreur chargement enfants", error);
        return [];
      }
    },
    onClick(item) {
      this.selectedId = item._id;
      this.$emit("change", item);
    },
  },
  watch: {
    itemId() {
      this.open = [];
      this.active = [];
      this.selectedId = null;
      this.treeKey++;
      this.loadRootItems();
    },
  },
};
</script>
